import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-button-back',
  templateUrl: './button-back.component.html',
  styleUrl: './button-back.component.scss',
  host: {
    'role': 'button',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonBackComponent {
  public readonly inside = input<boolean>(false);
}
